import { Loading } from '@carbon/react';
import style from './structure-grid-extraction-status.module.scss';
import classnames from 'classnames';

export type StructureGridExtractionStatusProps = {
  icon: React.ReactNode;
  heading: string;
  helperText?: string;
  footerText?: string;
  status?: 'processing' | 'failed';
};

export const StructureGridExtractionStatus = ({
  icon,
  heading,
  helperText,
  footerText,
  status = 'processing',
}: StructureGridExtractionStatusProps) => (
  <div className={style.processingState}>
    <div className={style.extractionDetailsLabel}>Extraction Details</div>
    <div className={style.icon}>{icon}</div>
    <div className={style.heading}>{heading}</div>
    {helperText && <div className={style.helperText}>{helperText}</div>}
    {status === 'processing' && (
      <Loading
        className={style.spinner}
        withOverlay={false}
        data-testid="structure-grid-extraction-processing-spinner"
      />
    )}
    {footerText && (
      <div
        className={classnames(style.footer, {
          [style.failed]: status === 'failed',
        })}
      >
        {footerText}
      </div>
    )}
  </div>
);
